// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	AddNewButton: 'add-new-button',
	RemoveButton: 'remove-button',
	CancelButton: 'cancel-button',
	SaveButton: 'save-button',
	PrimaryContactCheckbox: 'primary-contact-checkbox',
	SetAsPrimaryContactCheckbox: 'set-as-primary-contact-checkbox',
	CompanyName: 'company-name',
	BusinessPhone: 'business-phone',
	BusinessFax: 'business-fax',
	BusinessEmail: 'business-email',
	AuthorizedSigningOfficer: 'authorized-signing-officer',
	Title: 'title',
	PhoneNumber: 'phone-number',
	Email: 'email',
	//	MyHookName: 'myHookIdentifier',
} as const;
/*
NOTE: The above hooks have been auto generated, all naming is a best guess approach.
Please review them, edit where necessary and delete this comment to indicate that the names are correct.
*/
